export const members = [
    {
        name: "MB",
        picture: "./members/M01.jpg",
        desc: "Hey! My name is Michael Stokol—although most people just call me MB. I'm a composer and arranger based in Australia.| I organised the \"Perfect Arrange Works\" series of albums for Resonant Union. I love JRPGs and perhaps play a little too many of them, haha.",
        note: "Xenoblade Chronicles X Enthusiast",
        link: "https://linktr.ee/mbgov1133",
        color: "red"
    },
    {
        name: "Philip Saguil",
        picture: "./members/M02.jpg",
        desc: "Hey there! I'm Philip, though some call me FireFalls. I work as a freelance composer and sound designer, as well as a part of ECLIPSE Sound Team.| I organized the award-winning “Guru Guru Jam!”, and “Falcom Café”. Fun Fact? Hm… I play in Pokémon Draft Leagues in my freetime!",
        note: "Resident Kirby Superfan",
        link: "https://philipsaguil.com/",
        color: "green"
    },
    {
        name: "Recca",
        picture: "./members/M03.jpg",
        desc: "Hello, I'm Recca. I've organized several projects for Resonant Union: ZeroRanger Arranged Album -GREEN ARRANGE-, Falcom Boss Rush Phases I-III, Days of Adventure, and Resonant Saga.",
        link: "https://vgmdb.net/artist/56529",
        color: "blue"
    },
    {
        name: "R-Man",
        picture: "./members/M04.jpg",
        desc: "Hello, the name's Arman or uh... R-Man! I'm a composer, arranger, guitarist, and overall fix-it-all audio guy working in Sweden.| I've served as mastering engineer for most of Resonant Union's releases, and contribute tracks when I can. I love making all types of music but jazz and prog run in my veins!",
        note: "Self-proclaimed son of Masashi Hamauzu (false)",
        link: "https://www.youtube.com/@RManLovesGiantRobots/videos",
        color: "blue"
    },
]
